import {
  Attribute,
  Component,
  Template,
} from '@scoutgg/ftw/source/lib'
import template from './receivers.jade'
import '@scoutgg/ftw/source/atoms/toggle/toggle'
import '@scoutgg/ftw/source/atoms/icons/icons'
import Modal, { prompt } from '@scoutgg/ftw/source/services/modal'
import notify from '@scoutgg/ftw/source/services/notification'
import { Receiver } from '../../models'
import CreateNewReceiver from '../create-new-receiver'
import '../status'

@Component('sporty')
@Template(template)
export default class Receivers extends HTMLElement {
  attached() {
    this.reload()
  }

  filterReceivers(e) {
    this.applyState({ search: e.target.value.toLowerCase() })
  }

  reload() {
    this.update(Receiver.load({
      $reload: true,
    }))
  }

  get res() {
    const receivers = this.receivers || []
    const search = this.search || ''
    return receivers.filter(r => r.name.toLowerCase().includes(search))
  }

  remove(receiver) {
    prompt(`${receiver.url}`, {
      type: 'custom',
      className: 'remove-receivers',
      title: 'You want to remove receiver',
      submitBtnName: 'Confirm',
      cancelBtnName: 'Decline',
    }).then(() => {
      receiver.destroy().then(() => {
        notify(`Receiver ${receiver._id} has been destroyed.`, {
          level: 'success',
          timeout: 5000,
        })
        this.reload()
      }).catch(() => {
        return this.render()
      })

      this.render()
    })
  }

  copy(e) {
    let elem = e.target
    let input = elem.parentElement.querySelector('.input')
    input.select()
    document.execCommand('copy')
  }

  createReceiver() {
    return Modal(
      CreateNewReceiver(),
      { hideCloseBtn: true },
    ).then(() => this.reload(), () => {})
  }
}
